/**
 * The heading block every page opens with: an overline, a title and an optional lead.
 *
 * All three sit directly on the video rather than on a card, which is why they carry
 * `.text-on-video` — see `Section` for why that class exists. Extracted because eight pages
 * repeated the same three elements, and the one that did it slightly differently looked like a
 * bug rather than a variation.
 */

import { Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

export function PageHeading({
  overline,
  title,
  lead,
}: {
  overline: string;
  title: string;
  lead?: ReactNode;
}) {
  return (
    <Stack spacing={0.5}>
      <Typography variant="overline" className="text-white/70 text-on-video">
        {overline}
      </Typography>
      <Typography variant="h4" component="h1" className="text-white text-on-video">
        {title}
      </Typography>
      {lead ? (
        <Typography variant="body2" className="max-w-xl pt-1 text-white/85 text-on-video">
          {lead}
        </Typography>
      ) : null}
    </Stack>
  );
}
